
import { Component, Prop, Vue } from 'vue-property-decorator';
import { ValidationProvider } from 'vee-validate';

@Component<DeliveryOpenAddress>({
	components: {
		ValidationProvider
	}
})
export default class DeliveryOpenAddress extends Vue {
	@Prop({ type: Object, required: true, default: () => {} }) private restaurantDeliveryInfo!: DefaultDelivery;
	@Prop({ type: Object, required: true, default: () => {} }) private deliveryInformation!: CheckoutDeliveryInfo;

	private delivery: CheckoutDeliveryInfo = {
		type: 'open_address',
		address: ''
	};

	private mounted(): void {
		if (this.deliveryInformation) {
			this.delivery = { ...this.deliveryInformation, type: 'open_address' };
		}
	}

	private updateDeliveryInfo(): void {
		this.$emit('input', this.delivery);
	}
}
